import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_137: FaireProductEntity = {
  token: "legacy_prod_abbott-137",
  type: "product",
  name: "Brocade Print Umbrella Stand-Yellow & Blue-18 H",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/1c152465c4966bb6035e882b0d2de24f8ca2c4bb25554ece562ea3e49564287e.jpeg",
  priceDollars: 48,
  subcategory: "Decorative Objects",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_home-accents"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
